<div class="filter-spacing position-relative">
    <div class="select-box d-flex flex-column">
        <div class="select-container" #selectContainer [ngStyle]="{
            'max-width': this.getMaxWidth()+'px'
        }">
            <div class="bs-input-div th-bg-input th-input-border user-select-none" 
                 [id]="'subContainerfocus_'+this.getId()"
                 (click)="this.onSelectClick()"
                 [class.bs-disable-select]="getReadOnly()"
                 [class.th-bg-disabled]="getReadOnly()">
            
                <div class="d-flex h-100 text-center">
                   <div class="select-label bs-input-complete h-100 bs-input th-text-dark-gray" [id]="'selectLabel_'+this.getId()">
                        <div *ngIf="this.isLoading && this.options.length === 0 && this.defaultOption === ''">
                            Cargando...
                        </div>
                        <div *ngIf="this.options.length > 0 && this.defaultOption === ''">
                            {{this.getFirstOption()['text']}}
                        </div>
                        <div class="bs-placeholder th-text-gray-paragraphs" *ngIf="this.defaultOption !== ''">
                            {{this.getDefaultOption()}}
                        </div>
                   </div> 
                   <div class="ms-auto h-100 bs-icon d-flex align-items-center pe-2" [id]="'arrow_'+this.getId()">
                        <div *ngIf="this.showSortDescIcon">
                            <div class="select-icon" > 
                                <div class="bs-svg d-flex align-items-center">
                                    <object id="sort-desc-icon"
                                            data="assets/icons/sort-desc.svg"
                                            type="image/svg+xml"
                                            title="sort-desc">
                                    </object>
                                </div>
                            </div>
                        </div>
                        
                        <div *ngIf="this.showSortAscIcon">
                            <div class="select-icon"> 
                                <div class="bs-svg d-flex align-items-center">
                                    <object id="sort-asc-icon"
                                            data="assets/icons/sort-asc.svg"
                                            type="image/svg+xml"
                                            title="sort-asc">
                                    </object>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="this.showSortCloseIcon">
                            <div class="select-icon"> 
                                <div class="bs-svg d-flex align-items-center">
                                    <object id="sort-asc-icon"
                                            data="assets/icons/close.svg"
                                            type="image/svg+xml"
                                            title="sort-asc">
                                    </object>
                                </div> 
                            </div>
                        </div>
                   </div>
                </div>                
            </div>
            <div [ngStyle]="getDropdownMaxHeight()" class="options-container th-input-border" [id]="'optionsContainer_'+this.getId()">
                <div class="option bs-input-complete th-bg-input th-text-dark-gray" 
                     *ngFor="let option of options" (click)="this.onSelectOptionClick(option)">
                     <div>
                        <label>{{option.text}}</label>
                     </div>
                </div>
            </div>
            <small class="help-block bs-error th-text-alert" *ngIf="!this.getIsValid()">
                <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                {{getRequiredMessage()}}
            </small>
        </div>
    </div>
</div>
